<template>
  <div class="infowindow">
    <div class="container">
      <div class="head">
        {{ sensorData.curLipuValue }}通道粒谱
        <!-- 关闭方法通过props传入 -->
        <span class="close" @click="handleClose"
          ><a-icon type="close-circle"
        /></span>
      </div>
      <!-- 图表 -->
      <div class="chart">
        <div ref="chart" class="chart_part"></div>
      </div>
    </div>
    <!-- 底部三角 -->
    <div class="foot"></div>
  </div>
</template>

<script>
import axios from "axios";
import { gfChartOption } from "@/option/optionlipu";
import Highcharts from "highcharts";
import { mapState } from "vuex";
export default {
  name: "gfWindowInfo",
  data() {
    return {
      gfChartOption,
      title: "31",
    };
  },
  props: {
    sensorData: {
      type: Object,
    },
    handleClose: {
      type: Function,
    },
    yuzhi:{
      type:Number
    }
  },
  mounted() {
    // this.yuzhi && (this.gfChartOption.yAxis.max = this.yuzhi)
    this.init();
    this.getGfData();
  },

  methods: {
    init() {
      this.chart = Highcharts.chart(this.$refs.chart, this.gfChartOption);
      this.series = [];
    },
    getGfData() {
      const url = `http://jnwz.novaecs.com/172/py5010/get-029-device-data?time=${this.sensorData.time}&sn=${this.sensorData.sn}&data_type=${this.sensorData.data_type}`;
      axios
        .get(url)
        .then((res) => {
          const { status, data, message } = res.data;
          if (status === 1) {
            this.gfData = data;
            this.getSeries();
          }
        })
        // .catch((err) => console.log(err));
    },
    // series数据
    getSeries() {
      let sdata = [],
        curLipuValue = this.sensorData.curLipuValue || "31",
        pre = "PMCH";
      if (this.sensorData.curLipuValue == 6) {
        pre = "PMCH0";
      }
      sdata = Object.entries(this.gfData).filter((value, index, array) => {
        return value[0].indexOf(pre + curLipuValue) >= 0;
      });
      let tempoObj = {
        name: "",
        data: [],
        dataLabels: {
          enabled: false,
          rotation: -90,
          color: "#FFFFFF",
          align: "right",
          y: 10,
        },
        _colorIndex: 0
      };
      tempoObj.data = sdata;
      this.series = tempoObj;
      this.series.data.map(item=>{
        for(let v of G_SENSOR_DATA_TYPE_INFO){
         if (item[0] == v.value) {
            item[0]=v.name
          }
        }
      })

      this.chart.addSeries(this.series);

      this.categories = this.getCategories();
      //获取y周的最大值和最小值
      // this.getyValue();
      this.chart.update({
        xAxis: {
          categories: this.categories,

        },
      });
      this.getyValue();
    },
    // 获取x轴标签
    getCategories() {
      this.series.data.map((item) => {
        for (let v of G_SENSOR_DATA_TYPE_INFO) {
          if (item[0] == v.value) {
            item[0]=v.name
            return {
              ...item,
              ...v,
            };
          }
        }
      });
    },
    //获取y轴配置
    getyValue() {
      if(this.series.data.length==0||this.yuzhi===null)return
      if (this.yuzhi !== "" || this.yuzhi !== undefined) {
        this.chart.update({
          yAxis: {
            max: this.yuzhi,
            // tickAmount:3
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.infowindow {
  width: 322px;
  height: 200px;
  position: absolute;
  z-index: 2020;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  .container {
    width: 322px;
    background-color: #fff;
    .head {
      width: 322px;
      height: 40px;
      margin: 0 auto;
      padding: 0 15px 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #000;
      font-size: 18px;
      font-family: "PingFangSC-Medium, PingFang SC";
      font-weight: 500;
      line-height: 22px;
    }
    .chart {
      width: 322px;
      margin: 2px auto 0;
      .chart_head {
        width: 100%;
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        h5 {
          font-size: 12px;
          font-family: "PingFangSC-Regular, PingFang SC";
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 16px;
          margin-left: 56px;
        }
      }
      .chart_part {
        width: 300px;
        height: 200px;
      }
    }
  }
  .foot {
    margin: 0 auto;
    width: 0;
    height: 0;
    margin: 0 auto;
    border-width: 20px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/gfWindowInfo.vue